import { NgModule } from "@angular/core";

import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { LoaderComponent } from "../loader/loader.component";
import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from "primeng/calendar";


@NgModule({
    declarations: [
        LoaderComponent
    ],
    imports: [
        AccordionModule,
        ProgressSpinnerModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        DialogModule,
        DropdownModule,
        CalendarModule
    ],
    exports: [
        AccordionModule,
        LoaderComponent,
        TableModule,
        InputTextModule,
        ButtonModule,
        DialogModule,
        DropdownModule,
        CalendarModule
    ]
})
export class SharedModule { }
